import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { TenantData } from '../../../@core/interfaces/masters/tenant';
import { environment } from '../../../../environments/environment';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-otp-verify-dialog',
  templateUrl: './otp-verify-dialog.component.html',
  styleUrls: ['./otp-verify-dialog.component.css']
})
export class OtpVerifyDialogComponent implements OnInit {

  otpForm: FormGroup;
  @Input() phoneNum: string;
  @Input() emailId: string;
  @Input() verifyMailSuccess: boolean;
  @Input() tenantId: string;
  @Input() otpId: string;
  @Input() sendthroughsms: boolean;
  @Input() templateData:any;
  @Input() smscontent:string;
  @Input() branchID:string;
  @ViewChild("digit1") d1Element: ElementRef;
  @ViewChild("digit2") d2Element: ElementRef;
  @ViewChild("digit3") d3Element: ElementRef;
  @ViewChild("digit4") d4Element: ElementRef;
  @ViewChild("digit5") d5Element: ElementRef;
  @ViewChild("digit6") d6Element: ElementRef;
  @ViewChild("verifybtn") verifyBtnElement: ElementRef;
  //branchId:string;
  @Output() diaClose: EventEmitter<any> = new EventEmitter<any>();
  protected readonly unsubscribe$ = new Subject<void>();
  otpVerficationResponse: any;
  otpVerification: any;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  // Surfaces the backend's specific message (rate-limit/cooldown text from resendotp(), or the
  // verify failure reason from onVerify()) instead of the hardcoded "Incorrect OTP" for every
  // failure case. This dialog is shared across 5 parent pages, so fixing it here covers all of
  // them at once.
  otpErrorMessage: string = 'Incorrect OTP';

  // To declare sms_dto to set values written by Abirami Paramasivam / 24.05.21
  smsdto = { "variables": [], "template_id": "", "to": "", "service": "T" };
  branchName: string;
  tenantUserId: any;
  fromPage: string;
  get apiUrl(): string {
    return environment.apiUrl;
  }



  constructor(private routers: Router,protected rolesService: RolesData,public DatService:DateService,protected tenantSrvc: TenantData, private fb: FormBuilder, protected patRegSrvc: PatientRegistrationData) {
    this.otpForm = this.fb.group({
      digit1: this.fb.control('', [Validators.pattern('^[0-9-]+$'), Validators.maxLength(1), Validators.minLength(1)]),
      digit2: this.fb.control(''),
      digit3: this.fb.control(''),
      digit4: this.fb.control(''),
      digit5: this.fb.control(''),
      digit6: this.fb.control(''),
    });
  
    this.otpForm.get("digit1").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d2Element.nativeElement.focus());
    this.otpForm.get("digit2").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d3Element.nativeElement.focus());
    this.otpForm.get("digit3").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d4Element.nativeElement.focus());
    this.otpForm.get("digit4").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d5Element.nativeElement.focus());
    this.otpForm.get("digit5").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d6Element.nativeElement.focus());
    this.otpForm.get("digit6").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.verifyBtnElement.nativeElement.focus());
  }
  get fval() { return this.otpForm.controls; }
  ngOnInit(): void {
    this.fetchTenantBranch();
    if(!!this.d1Element)
    this.d1Element.nativeElement.focus();
  }
  fromTenantRegistration(phoneNum, id, otpId) {
    this.phoneNum = phoneNum;
    this.tenantId = id;
    this.otpId = otpId;
    if(!!this.d1Element)
    this.d1Element.nativeElement.focus();
  }

  fromforgotPassword(fromPage) {
    this.fromPage = fromPage;
    if(!!this.d1Element)
    this.d1Element.nativeElement.focus();
  }

  fromPatientPortal(phoneNum, id, otpId, frompage) {
    this.phoneNum = phoneNum;
    this.tenantId = id;
    this.otpId = otpId;
    this.fromPage = frompage;
    if(!!this.d1Element)
    this.d1Element.nativeElement.focus();
  }
  resendotp() {
    let data = {
      "headers": {
        "Accept": "application/vnd.ezovion.hateoas+json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    }
    this.otpId="";
    this.isFailure = false;
    // SECURITY: the backend no longer returns the OTP value, only { success, message }.
    // Verification of the user-entered code happens entirely server-side (see onVerify()).
    var url = `${this.apiUrl}/patientportalnewuser/${this.tenantId}/sendotp/${this.phoneNum}`;
    if(this.emailId && this.verifyMailSuccess){
      url += `/${this.emailId}`;
    }
    this.rolesService.create(url,data).pipe(takeUntil(this.unsubscribe$)).subscribe((response: any) => {
      // Non-secret marker only - indicates an OTP has been sent, never the OTP value itself.
      this.otpId = response && response.success ? 'sent' : '';
      this.otpVerification = response;
    }, (error) => {
      // Send failed (e.g. rate-limit/cooldown 429) - surface the backend's message instead of
      // failing silently, since this dialog is already open when resend is clicked.
      this.otpErrorMessage = (error && error.error && error.error.message) || 'Unable to send OTP. Please try again.';
      this.isFailure = true;
    }, () => {
      // NOTE: this branch previously re-sent the OTP text through a tenant-purchased SMS
      // template/gateway (this.templateData) by embedding the plaintext OTP value in the
      // message. Since the OTP is no longer available client-side (by design, per the
      // security fix), this dual-channel delivery can no longer be performed from the
      // frontend and is disabled here rather than sending a message with no real OTP in it.
      // If tenant-custom-gateway OTP delivery is still required, it needs to be implemented
      // server-side (e.g. inside AutoCommunGroupRepository.SendSMSOTPToUser) where the
      // generated code is actually available.
      if(this.sendthroughsms){
        // Intentionally not sending - see note above.
      }
    });

    // if (this.fromPage == "PatientPortal" ||this.fromPage == "forgotPassword" ) {

    //   this.patRegSrvc.sendMessageOtp("patientportalnewuser/" + this.tenantId + '/sendotp/' + this.phoneNum, this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    //     this.otpVerification = data;
    //     this.otpId = data;
    //   }, (error) => {
    //   }, () => {
    //   });
    // }
    // else {
    //   this.patRegSrvc.sendMessageOtp("communication/" + this.tenantId + '/' + this.tenantId + '/sendotp/' + this.phoneNum, this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    //     this.otpVerification = data;
    //     this.otpId = data;
    //   }, (error) => {
    //   }, () => {
    //   });
    // }

   
  }
  onVerify() {

    let otp = "";
    otp += this.otpForm.get('digit1').value;
    otp += this.otpForm.get('digit2').value;
    otp += this.otpForm.get('digit3').value;
    otp += this.otpForm.get('digit4').value;
    otp += this.otpForm.get('digit5').value;
    otp += this.otpForm.get('digit6').value;
  
    if (otp !== "") {
      // SECURITY: verification happens entirely server-side; the frontend never compares
      // the entered code against a locally-held OTP value.
      const verifyPayload = {
        otpCode: otp,
        userMobileNumber: this.phoneNum,
        emailId : this.emailId?this.emailId : null,
      };
      this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${this.tenantId}/verifyotp`, verifyPayload).pipe(takeUntil(this.unsubscribe$)).subscribe((result: any) => {
        if (result && result.code === 200) {
          this.isSuccess = true;
          this.isFailure = false;
          this.diaClose.emit({ otpStatus: "approved" });

          if (this.fromPage !== "PatientPortal" && this.fromPage !== "forgotPassword") {
            this.sendsms();
          }
        } else {
          this.otpErrorMessage = (result && result.status) || 'Incorrect OTP';
          this.isFailure = true;
          this.isSuccess = false;
        }

        this.otpForm.reset();
      }, (error) => {
        this.otpErrorMessage = (error && error.error && error.error.status) || 'Incorrect OTP';
        this.isFailure = true;
        this.isSuccess = false;
        this.otpForm.reset();
      });
    }
  }
  onCancel() {

    this.diaClose.emit(null);
  }
  fetchTenantBranch(): void {
      this.tenantSrvc.getById(`${this.apiUrl}/patientportalnewuser/${this.tenantId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

        this.branchName = data.name;
        this.tenantUserId = data.tenantUserId;
      }, (error) => {

      }, () => {
      });
      }

  // To implement sms send function written by Abirami Paramasivam / 24.05.21
  sendsms() {
    this.fetchTenantBranch();
    // To set template variables and template id for to send sms using these template id written by Abirami Paramasivam / 24.05.21
    //  this.sms_dto.variables=[this.branchName,this.tenantUserId];
    this.smsdto.variables = [this.branchName];
    this.smsdto.template_id = "238f0995-b840-4a61-a832-7bf7cd224d9c";
    // To call server side api for sms sending written by Abirami Paramasivam / 24.05.21
    this.patRegSrvc.sendgreetingsMessage("communication/" + this.tenantId + '/' + this.tenantId + '/send_greetings_message/' + this.phoneNum, this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    }, (error) => {
    }, () => {
    });
  }




}
